import { useMemo } from "react";
import { RedactFootagePreviewItem } from "src/store/api/generatedApi";
import { VideoControlProvider } from "../VideoPlayer/contexts/VideoControlContext";
import { HotkeyProvider } from "../VideoPlayer/contexts/HotkeyContext";
import { MultiFeedVideoPlayer } from "../VideoPlayer/components/MultiFeedVideoPlayer";
import { VideoSource } from "../VideoPlayer/components/VideoSourceSelector";
import { PLAYBACK_SCOPE } from "components/scrapEyeDataDashboard/VideoPlayer/constants";

export const RedactionVideoPreview = ({
  items,
  startIso,
  endIso,
}: {
  items: RedactFootagePreviewItem[];
  startIso: string;
  endIso: string;
}) => {
  const source: VideoSource = useMemo(
    () => ({
      mode: "camera" as const,
      cameras: items.map((item) => ({
        deviceId: item.device_id,
        physicalId: item.camera_physical_id,
      })),
    }),
    [items]
  );

  return (
    <HotkeyProvider>
      <VideoControlProvider>
        <MultiFeedVideoPlayer
          hotkeyScope={PLAYBACK_SCOPE}
          source={source}
          startIso={startIso}
          endIso={endIso}
          showVideoControls
          gridLayout={{ columnsPerRow: Math.min(items.length, 3) }}
        />
      </VideoControlProvider>
    </HotkeyProvider>
  );
};
